module.exports = __webpack_public_path__ + "static/media/portrait.8895662e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Hero/Portrait/portrait.png
// module id = 112
// module chunks = 0